/* RUCA theme scripts — progressive enhancement only.
   Every feature below has a working no-JS fallback. */
(function () {
  "use strict";

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* Mobile navigation ---------------------------------------------------- */
  document.querySelectorAll("[data-nav-toggle]").forEach(function (btn) {
    var panel = document.getElementById(btn.getAttribute("aria-controls"));
    if (!panel) return;
    btn.addEventListener("click", function () {
      var open = btn.getAttribute("aria-expanded") === "true";
      btn.setAttribute("aria-expanded", String(!open));
      panel.hidden = open;
      if (!open) {
        var first = panel.querySelector("a, button");
        if (first) first.focus();
      }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && btn.getAttribute("aria-expanded") === "true") {
        btn.setAttribute("aria-expanded", "false");
        panel.hidden = true;
        btn.focus();
      }
    });
  });

  /* Hero slideshow -------------------------------------------------------
     WCAG 2.2.2: auto-rotation is pausable, stops on focus/hover, and never
     starts when the visitor prefers reduced motion. */
  document.querySelectorAll("[data-slideshow]").forEach(function (root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll("[data-slide]"));
    if (slides.length < 2) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll("[data-dot]"));
    var live = root.querySelector("[data-live]");
    var toggle = root.querySelector("[data-toggle]");
    var interval = parseInt(root.dataset.interval, 10) || 6000;
    var index = 0;
    var timer = null;
    var playing = false;

    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.dataset.active = String(active);
        slide.setAttribute("aria-hidden", String(!active));
        slide.querySelectorAll("a, button").forEach(function (el) {
          if (active) { el.removeAttribute("tabindex"); } else { el.setAttribute("tabindex", "-1"); }
        });
      });
      dots.forEach(function (dot, i) { dot.setAttribute("aria-current", String(i === index)); });
      if (live) live.textContent = "Slide " + (index + 1) + " of " + slides.length;
    }

    function play() {
      if (playing) return;
      playing = true;
      timer = setInterval(function () { show(index + 1); }, interval);
      if (toggle) { toggle.setAttribute("aria-pressed", "true"); toggle.setAttribute("aria-label", "Pause slideshow"); toggle.textContent = "❚❚"; }
    }
    function pause() {
      playing = false;
      clearInterval(timer);
      if (toggle) { toggle.setAttribute("aria-pressed", "false"); toggle.setAttribute("aria-label", "Play slideshow"); toggle.textContent = "▶"; }
    }

    root.querySelectorAll("[data-prev]").forEach(function (b) { b.addEventListener("click", function () { pause(); show(index - 1); }); });
    root.querySelectorAll("[data-next]").forEach(function (b) { b.addEventListener("click", function () { pause(); show(index + 1); }); });
    dots.forEach(function (dot, i) { dot.addEventListener("click", function () { pause(); show(i); }); });
    if (toggle) toggle.addEventListener("click", function () { playing ? pause() : play(); });

    root.addEventListener("mouseenter", function () { if (playing) { clearInterval(timer); } });
    root.addEventListener("mouseleave", function () { if (playing) { timer = setInterval(function () { show(index + 1); }, interval); } });
    root.addEventListener("focusin", pause);

    root.addEventListener("keydown", function (e) {
      if (e.key === "ArrowLeft") { pause(); show(index - 1); }
      if (e.key === "ArrowRight") { pause(); show(index + 1); }
    });

    var startX = null;
    root.addEventListener("touchstart", function (e) { startX = e.touches[0].clientX; }, { passive: true });
    root.addEventListener("touchend", function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 45) { pause(); show(dx < 0 ? index + 1 : index - 1); }
      startX = null;
    });

    show(0);
    if (root.dataset.autoplay === "true" && !reduceMotion) { play(); } else { pause(); }
  });

  /* Portfolio category filter --------------------------------------------
     Links still point at real tag URLs, so crawlers and no-JS visitors get
     the full, indexable listing. */
  document.querySelectorAll("[data-portfolio]").forEach(function (root) {
    var buttons = Array.prototype.slice.call(root.querySelectorAll("[data-filter]"));
    var items = Array.prototype.slice.call(root.querySelectorAll("[data-categories]"));
    var count = root.querySelector("[data-count]");
    if (!buttons.length) return;

    buttons.forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        var value = btn.dataset.filter;
        var shown = 0;
        buttons.forEach(function (b) { b.setAttribute("aria-pressed", String(b === btn)); });
        items.forEach(function (item) {
          var match = value === "all" || (item.dataset.categories || "").split("|").indexOf(value) !== -1;
          item.hidden = !match;
          if (match) shown++;
        });
        if (count) count.textContent = shown + (shown === 1 ? " work" : " works");
      });
    });
  });

  /* Product gallery thumbnails ------------------------------------------- */
  document.querySelectorAll("[data-gallery]").forEach(function (root) {
    var main = root.querySelector("[data-gallery-main]");
    root.querySelectorAll("[data-gallery-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        if (!main) return;
        main.src = thumb.dataset.full;
        main.srcset = thumb.dataset.fullSrcset || "";
        main.alt = thumb.dataset.alt || main.alt;
        root.querySelectorAll("[data-gallery-thumb]").forEach(function (t) { t.setAttribute("aria-current", String(t === thumb)); });
      });
    });
  });

  /* Quantity stepper ------------------------------------------------------ */
  document.querySelectorAll("[data-qty]").forEach(function (root) {
    var input = root.querySelector("input");
    root.querySelectorAll("button").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var step = btn.dataset.step === "down" ? -1 : 1;
        var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = next;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });
  });
})();
